<div class="expression-container">
  <mat-form-field class="expression-item">
    <mat-label>Field</mat-label>
    <mat-select [(value)]="field">
      @for (field of fieldValues; track field) {
        <mat-option [value]="field.key">
          {{ field.value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="expression-item">
    {{ getComparisonString(comparison) }}
  </div>

  <mat-form-field class="expression-item">
    <mat-label>Value</mat-label>
    <mat-select [(value)]="value">
      @for (field of valueValues; track field) {
        <mat-option [value]="field.key">
          {{ field.value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="expression-item">
    <button
      mat-icon-button
      color="warn"
      matTooltip="Remove expression rule"
      (click)="onExpressionRuleRemoved()">
      <mat-icon>playlist_remove</mat-icon>
    </button>
  </div>
</div>
